<template>
  <div class="page_bg">
    <div>
      <van-image width="10rem" height="5.5rem"
                 src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my/1.png"
      />
      <van-image width="10rem" height="8rem"
                 src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my/2.png"
      />
      <van-image width="10rem" height="8rem"
                 src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my/3.png"
      />
      <van-image width="10rem" height="2rem"
                 src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/my/4.png"
      />
    </div>
    <div class="mask flex-r-c-c">
      <div class="certification_dialog flex-c-c-c">
        <div class="certification_dialog_close">
          <van-icon name="close" color="#333" @click="reLogin" />
        </div>
        <van-image width="4.11rem" height="2.75rem"
                   src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/shop2.0/home/certification.png"
        />
        <div class="certification_title"> 您尚未提交认证资料 </div>
        <div class="certification_tip"> 暂时无法采购 </div>
        <van-button class="certification_btn" round type="info" color="#0767ab" @click="toUpCertification">立即认证
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreCertification',
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {
    // 去认证
    toUpCertification() { this.$router.push('/home/certification') },
    // 去登陆
    reLogin() {
      this.$router.push('/user/login')
    }
  }
}
</script>

<style lang="scss">
.mask {
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 10rem;
  height: 25rem;
}
.certification_dialog {
  margin-top: -3rem;
  width: 9rem;
  height: 8.8rem;
  background: linear-gradient(180deg, #d4e9fa 0%, #ffffff 100%);
  border-radius: 0.27rem;

  .certification_title {
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.81rem;
    color: #333333;

    margin-top: 0.56rem;
  }
  .certification_tip {
    font-size: 0.37rem;
    color: #999999;

    margin-top: 0.05rem;
  }
  .certification_btn {
    width: 4.8rem;
    height: 1.17rem;
    opacity: 1;
    border-radius: 0.59rem;

    margin-top: 0.69rem;
  }
}
.certification_dialog_close {
  width: 90%;
  text-align: right;
  font-size: 0.6rem;

  margin-top: -0.5rem;
}
</style>
